// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2UbiO","title":"Header_title__2TDvH","left":"Header_left__2Yxh3","clinicName":"Header_clinicName__1OkVL"};